import React from 'react';
import { Modal, Button, Form, Row, Col, Alert } from 'react-bootstrap';
import Select from 'react-select';
import { Formik, Field, ErrorMessage } from 'formik';
import { toast } from 'react-toastify';
import { selectStylesSm, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { mudarFaseContrato } from '~/Services/Juridico/ControleContratoService';
import { schemaMudarFase } from './validationSchemas';
import { extrairMensagemErro } from './useControleContrato';

// Fases disponíveis para seleção (ADR-003: fase 4 escolhida → backend grava 8)
const FASES_OPCOES = [
  { value: 1, label: '1 — Não Enviados' },
  { value: 2, label: '2 — Já Enviados' },
  { value: 3, label: '3 — Já Retornados' },
  { value: 4, label: '4 — Assinado Diretoria' },
  { value: 5, label: '5 — Assinaturas Finalizadas' },
  { value: 6, label: '6 — Quitado Recurso Próprio' },
];

// Fases que exigem anexo
const FASES_EXIGEM_ANEXO = [7, 9, 10, 12];

const ModalMudarFase = ({ show, onHide, contrato, onSalvo }) => {
  if (!contrato) return null;

  const valoresIniciais = {
    faseEscolhida: '',
    titulo: '',
    observacao: '',
    anexos: [],
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await mudarFaseContrato({
        codigoGrupoEmpresa: contrato.codigo_grupo_empresa,
        codigoConta: contrato.conta,
        codigoBoleto: contrato.boleto,
        faseEscolhida: Number(values.faseEscolhida),
        titulo: values.titulo,
        observacao: values.observacao || null,
        anexos: values.anexos || [],
      });
      toast.success('Fase alterada com sucesso.');
      onSalvo();
    } catch (err) {
      toast.error(extrairMensagemErro(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          Mudar Fase — Boleto {contrato.boleto} / Conta {contrato.conta}
        </Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={valoresIniciais}
        validationSchema={schemaMudarFase}
        onSubmit={handleSubmit}
      >
        {({ handleSubmit: formSubmit, isSubmitting, values, setFieldValue }) => (
          <Form onSubmit={formSubmit}>
            <Modal.Body>
              <Alert variant="info" className="small">
                A fase escolhida &quot;Assinado Diretoria&quot; (4) é registrada internamente
                como fase 8 (Quitado AE + Procuração) — comportamento automático do sistema.
              </Alert>
              <Row>
                <Col xs={12} sm={6}>
                  <Form.Group>
                    <Form.Label className="small mb-1">Fase *</Form.Label>
                    <Select
                      placeholder="Selecione a fase..."
                      options={FASES_OPCOES}
                      value={
                        FASES_OPCOES.find(
                          (o) => o.value === Number(values.faseEscolhida)
                        ) || null
                      }
                      onChange={(sel) =>
                        setFieldValue('faseEscolhida', sel ? sel.value : '')
                      }
                      isClearable
                      styles={selectStylesSm}
                      components={{ DropdownIndicator }}
                    />
                    <ErrorMessage name="faseEscolhida">
                      {(msg) => <small className="text-danger">{msg}</small>}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group>
                <Form.Label className="small mb-1">Título *</Form.Label>
                <Field
                  as={Form.Control}
                  size="sm"
                  type="text"
                  name="titulo"
                  placeholder="Título do item de fase"
                  maxLength={30}
                />
                <ErrorMessage name="titulo">
                  {(msg) => <small className="text-danger">{msg}</small>}
                </ErrorMessage>
              </Form.Group>
              <Form.Group>
                <Form.Label className="small mb-1">Observação</Form.Label>
                <Field
                  as="textarea"
                  className="form-control form-control-sm"
                  name="observacao"
                  rows={3}
                  maxLength={2000}
                />
                <ErrorMessage name="observacao">
                  {(msg) => <small className="text-danger">{msg}</small>}
                </ErrorMessage>
              </Form.Group>
              {FASES_EXIGEM_ANEXO.includes(Number(values.faseEscolhida)) && (
                <Alert variant="warning" className="small">
                  Esta fase requer pelo menos um anexo de documento.
                </Alert>
              )}
              <ErrorMessage name="anexos">
                {(msg) => <small className="text-danger d-block">{msg}</small>}
              </ErrorMessage>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" size="sm" onClick={onHide} disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button variant="primary" size="sm" type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Confirmar Mudança de Fase'}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModalMudarFase;
